import gql from 'graphql-tag';

export const tasksQuery = gql`
  query tasks(
    $groupIds: [String]!
    $search: FindTasksSearch
    $pagination: PaginationInput
    $filter: TaskFilterDTO
    $preFilter: TaskPreFilterDTO
  ) {
    tasks(
      groupIds: $groupIds
      pagination: $pagination
      search: $search
      filter: $filter
      preFilter: $preFilter
    ) {
      tasks {
        id
        groupBy {
          name
          id
        }
        dueDate
        repeats {
          label
          value
        }
        estimateTimeToComplete
        assignee {
          _id
          name
        }
        assigneeGroup {
          _id
          name
        }
        notes
        steps
        meterReading
        createdBy
        updatedBy
        completedBy
        equipment {
          id
          location
          name
          category
          floor
          suite
        }
        createdAt
        updatedAt
        completedAt
        isArchived
        location
        actualTimeToComplete
        completeNotes
        status
        nextStatuses
        schedule {
          id
          title
        }
        friendlyID
        userFriendlyID
      }
      pageInfo {
        start
        total
        perPage
      }
    }
  }
`;
